<template>
  <div class="min-h-screen bg-gradient-to-br from-gray-800 via-gray-700 to-gray-600 flex items-center justify-center p-4">
    <div class="max-w-md w-full text-center fade-in">
      <div class="w-20 h-20 bg-gray-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
        <font-awesome-icon icon="exclamation-triangle" class="text-gray-300 text-3xl" />
      </div>
      <h1 class="text-2xl font-bold text-white mb-2">Link Expired or Invalid</h1>
      <p class="text-gray-300 mb-6">
        This access link has expired or is no longer valid. Please contact the loan officer to request a new link.
      </p>
      <div class="text-sm text-gray-400">
        <p>If you believe this is an error, please try:</p>
        <ul class="mt-2 space-y-1">
          <li>• Using the original link from your email</li>
          <li>• Clearing your browser cache</li>
          <li>• Contacting the loan officer directly</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LinkExpired',
}
</script>





